import * as yup from 'yup';
import { validateShipmentTrackingNumber, validateSsn } from '../../helpers/formHelpers/formHelpers';
import ISendReceipt from '../../interfaces/sendReceipt/sendReceiptMultistep';

export const sendReceiptInitialValues: ISendReceipt = {
	foreignSsn: false,
	identificationNumber: '',
	name: '',
	phone: '',
	email: '',
	instructionsToStaff: 'hasInvoice',
	hasReceipt: 'Yes',
	deliveryService: '0',
	files: [],
	additionalInformation: '',
	trackingNumbers: [],
	isCompany: false,
	openUp: '',
	giftType: null,
	clearedTrackingNumber: '',
	acceptedTerms: false,
};
const noStandaloneNumbers = /^(?!.*\b\d+\b)(?!\d+$).*$|^(?=.*\d)(?=.*[a-zA-Z]).*$/;

export const sendReceiptSchema = yup.object().shape({
	foreignSsn: yup.boolean(),
	identificationNumber: yup.string().when('foreignSsn', {
		is: false,
		then: yup.string().required('required').min(10, 'ssn-min').test('is-valid-ssn', 'ssn-valid', validateSsn),
	}),
	name: yup.string().required('required').matches(noStandaloneNumbers, 'name-invalid'),
	phone: yup
		.string()
		.min(7, 'phone-min')
		.max(7, 'phone-max')
		.matches(/^[6-8][0-9]*$/, 'phone-invalid'),
	email: yup.string().email('email-invalid').required('required'),
	instructionsToStaff: yup.string().when('hasReceipt', {
		is: 'No',
		then: yup.string().required('required'),
	}),
	hasReceipt: yup.string().required('required'),
	deliveryService: yup.string().oneOf(['0', '1', '2', '3', '4']).required('required'),
	files: yup
		.array()
		.of(yup.object().nullable())
		.min(0, 'file-min')
		.when('hasReceipt', {
			is: 'Yes',
			then: yup.array().of(yup.object().nullable()).min(1, 'file-min'),
		})
		.when('instructionsToStaff', {
			is: 'alreadyCleared',
			then: yup.array().of(yup.object().nullable()).min(1, 'file-min'),
		}),
	additionalInformation: yup
		.string()
		.max(255, 'content-max')
		.when('instructionsToStaff', {
			is: 'hasInvoice',
			then: yup.string().required('required').max(255, 'content-max'),
		})
		.when('instructionsToStaff', {
			is: 'alreadyCleared',
			then: yup.string().required('required').max(255, 'content-max'),
		})
		.when('instructionsToStaff', {
			is: 'other',
			then: yup.string().required('required').max(255, 'content-max'),
		})
		.when(['instructionsToStaff', 'giftType'], {
			is: (instructionsToStaff: string, giftType: { value: string }) =>
				instructionsToStaff === 'gift' && giftType?.value === 'otherGift',
			then: yup.string().required('required').max(255, 'content-max'),
		}),
	trackingNumbers: yup.array().of(yup.string()).min(1, 'trackingnumber-min'),
	openUp: yup.string().when('instructionsToStaff', {
		is: 'openUp',
		then: yup.string().required('required'),
	}),
	giftType: yup
		.object()
		.nullable()
		.shape({
			label: yup.string(),
			value: yup.string(),
		})
		.when('instructionsToStaff', {
			is: 'gift',
			then: yup.object().shape({
				label: yup.string().required('required').min(1, 'gift-type-required'),
				value: yup.string().required('required').min(1, 'gift-type-required'),
			}),
		}),
	clearedTrackingNumber: yup.string().when('instructionsToStaff', {
		is: 'alreadyCleared',
		then: yup
			.string()
			.test('is-valid-cleared-tracking-number', 'invalid-cleared-tracking-number', validateShipmentTrackingNumber)
			.required('required'),
	}),
	acceptedTerms: yup.boolean().required('required'),
});
